import { type IconId, PixelIcon } from "@/components/PixelIcon/PixelIcon";
import Spinner from "@/images/spinner.svg";
import { clsx } from "clsx";
import { forwardRef } from "react";
import css from "./Button.module.scss";

type Props = React.ComponentProps<"button"> & {
  variant?: "primary" | "secondary";
  size?: "normal" | "large" | "small";
  icon?: IconId;
  active?: boolean;
  isSuperUserButton?: boolean;
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(props, ref) {
  const {
    className,
    variant = "primary",
    size = "normal",
    type = "button",
    icon,
    active,
    isSuperUserButton,
    children,
    ...buttonProps
  } = props;

  return (
    <button
      ref={ref}
      className={clsx(css.button, className)}
      type={type}
      {...buttonProps}
      data-variant={variant}
      data-size={size}
      data-active={active}
      data-disabled={buttonProps.disabled}
    >
      {icon && (
        <span className={css.iconContainer}>
          <PixelIcon className={css.icon} icon={icon} />
        </span>
      )}
      <span className={css.children}>{children}</span>
      {isSuperUserButton && (
        <span className={css.superUserIconContainer}>
          <span className={css.superUserIcon}>🥷</span>
        </span>
      )}
      {active && <Spinner className={css.spinner} aria-hidden={true} />}
    </button>
  );
});
